import { render, staticRenderFns } from "./creditNoteCancelDialog.vue?vue&type=template&id=508d41f4&scoped=true&"
import script from "./creditNoteCancelDialog.vue?vue&type=script&lang=js&"
export * from "./creditNoteCancelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d41f4",
  null
  
)

export default component.exports